export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";